// Hashes (DESIGN_SPEC §10.5). Identifiers are mono, never translated.
//   <Hash value />         full hash in 8-char groups (SHA-256 wraps to two lines of 32); copying yields one string
//   <Hash value short />   8…8 in faint ink (`a3f1c9e8…9a28b7c0`), the full value in the title
import { cx } from "./cx";

const shortHash = (h: string) => (h.length > 20 ? `${h.slice(0, 8)}…${h.slice(-8)}` : h);

export function Hash({ value, short, className }: { value: string; short?: boolean; className?: string }) {
  if (short)
    return (
      <span className={cx("hash8", className)} translate="no" title={value}>
        {shortHash(value)}
      </span>
    );
  return (
    <span className={cx("hash", className)} translate="no">
      {value.match(/.{1,8}/g)?.map((g, i) => <span key={i}>{g}</span>)}
    </span>
  );
}
